import { useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";

import { yellow } from "@mui/material/colors";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import Container from "react-bootstrap/Container";

import Avatar from "@mui/material/Avatar";
import Tooltip from "@mui/material/Tooltip";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";

import LightModeOutlinedIcon from "@mui/icons-material/LightModeOutlined";
import NightlightOutlinedIcon from "@mui/icons-material/NightlightOutlined";

import DashFooter from "./DashFooter";
import NavBarHeader from "./NavBarHeader";
import SideBarLayout from "../SideBarLayout/SideBarLayout";
import EditLabelsForm from "../../features/labels/EditLabelsForm";
import { useGetUserQuery } from "../../features/user/userApiSlice";
import { useSendLogoutMutation } from "../../features/auth/authApiSlice";

const acSettings = ["Profile", "Account", "Logout"];
const color = yellow[500];
function NavBarLayout(props) {
  const navigate = useNavigate();
  //const { data: user } = useSelector(selectUserResult);
  const { data: user } = useGetUserQuery("User");
  const [isDark, setIsDark] = useState(props.theme);
  const [toggle, setToggle] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [anchorElUser, setAnchorElUser] = useState(null);
  const [
    sendLogout,
    {
      isLoading: isLoadingOut,
      isSuccess: isSuccessOut,
      isError: isErrorOut,
      error: errorOut,
    },
  ] = useSendLogoutMutation();

  function toggleSideBar() {
    setToggle(!toggle);
  }
  function handleOpenEditLabelsDialog() {
    setOpenDialog(true);
  }
  function handlCloseEditLabelsDialog() {
    setOpenDialog(false);
  }
  function switchTheme() {
    props.onSwitchTheme();
  }
  function handleOpenUserMenu(event) {
    setAnchorElUser(event.currentTarget);
  }
  function handleCloseUserMenu() {
    setAnchorElUser(null);
  }
  function onAcMenuItemClick(event) {
    const { menuItem } = event.currentTarget.dataset;
    switch (menuItem) {
      case "Profile":
        navigate("/user/manage-profile");
        break;
      case "Account":
        navigate("/user/manage-account");
        break;
      case "Logout":
        sendLogout();
        break;
      default:
        break;
    }
    handleCloseUserMenu();
  }
  useEffect(() => {
    setIsDark(props.theme);
    const root = document.documentElement;
    root?.style.setProperty("--BGCOLOR", props.style.backgroundColor);
    root?.style.setProperty("--HELPER-BGCOLOR", props.style.backgroundColor);
    root?.style.setProperty("--BUTTON-HOVER", props.style.btnHoverColor);
    root?.style.setProperty("--COLOR", props.style.color);
    if (isSuccessOut) {
      navigate("/login");
    }
  }, [isDark, props.style, props.theme, isSuccessOut, navigate]);
  if (isLoadingOut) return <p>Logging Out...</p>;
  if (isErrorOut) return <p>Error: {errorOut.data?.message}</p>;

  return (
    <div className="main-wrapper">
      <Navbar
        className="main-header"
        expand="lg"
        bg={isDark ? "dark" : "light"} //{"transparent"} //{"black"} //{"transparent"} //{isDark ? "dark" : "light"}
        variant={isDark ? "dark" : "light"}
      >
        <Container fluid>
          <Navbar.Toggle
            className="navbar-toggle"
            placement="start"
            type="button"
            onClick={() => toggleSideBar()}
          />
          <Navbar.Brand className="navbar-brand">
            <NavBarHeader />
          </Navbar.Brand>
          <Nav>
            <IconButton onClick={switchTheme}>
              {isDark ? (
                <LightModeOutlinedIcon sx={{ color: { color } }} />
              ) : (
                <NightlightOutlinedIcon />
              )}
            </IconButton>
          </Nav>
          <Tooltip title="Open settings">
            <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
              <Avatar
                alt="UserName"
                src={user ? user.avatar.data : ""} /*user.avatar.data : ""}*/
              />
            </IconButton>
          </Tooltip>
          <Menu
            sx={{ mt: "45px" }}
            anchorEl={anchorElUser}
            anchorOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            keepMounted
            transformOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            open={Boolean(anchorElUser)}
            onClose={handleCloseUserMenu}
          >
            {acSettings.map((setting) => (
              <MenuItem
                key={setting}
                data-menu-item={setting}
                onClick={(e) => onAcMenuItemClick(e)}
              >
                <Typography textAlign="center">{setting}</Typography>
              </MenuItem>
            ))}
          </Menu>
        </Container>
      </Navbar>
      <SideBarLayout
        onEditLabelsClick={handleOpenEditLabelsDialog}
        toggle={toggle}
        style={props.style}
      />
      <Outlet className="main-container" />
      <EditLabelsForm open={openDialog} onClose={handlCloseEditLabelsDialog} />
      <DashFooter style={props.style} />
    </div>
  );
}

export default NavBarLayout;
